export default __webpack_public_path__ + "static/media/notes.c2721f75.png";